<template>
    <div class="purchase-main clearfix">
        <compWrapper theme="primary" title="基本信息">
            <div class="padding-15">
                <compFormQuery v-if="type == 'query'" :formdata="getBase" :value="formData"></compFormQuery>
                <compFormEdit ref="dataForm" v-else v-model="formData" :formdata="getBase"></compFormEdit>
            </div>
        </compWrapper>
        <div v-if="type != 'query'" class="button-container pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">确认</Button>
            <Button @click="cancel">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetPurchaseMainDetail,
    HttpUpdatePurchaseMain
} from "@/service/purchase/purchase";
export default {
    props: ['querytype', 'activeid'],
    data () {
        return {
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            formData: {},
            loading: false
        }
    },
    created () {
        if (this.type != 'add') {
            this.getDetail()
        }
    },
    methods: {
        async getDetail () {
            this.loading = true;
            await HttpGetPurchaseMainDetail({
                id: this.id,
            }).then(res => {
                this.formData = res.data;
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        async submit () {
            await this.$refs.dataForm.validate();
            this.loading = true;
            await HttpUpdatePurchaseMain({
                id: this.id,
                orgId: global.SYSID,
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-update');
                this.$emit('on-close');
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        cancel () {
            this.$emit('on-close');
        },
    },
    computed: {
        getBase () {
            return [
                {
                    label: "采购主体（买方）中文名称",
                    key: "name"
                },
                {
                    label: "采购主体（买方）英文名称",
                    key: "nameEn"
                },
                {
                    label: "备注",
                    key: "remark",
                    required: false
                }
            ]
        }
    }
}
</script>

<style>

</style>